import { ListableInfo, type MenuItem, Panel } from '@ics-portal/guardian';
import type { ReactNode } from 'react';
import InfoCardWrapper from './Layout/InfoCardWrapper';

export interface InfoCardBulkSelectionField {
    label: string;
    value: ReactNode;
}

export interface InfoCardBulkSelectionItem {
    key: string;
    panelHeader: string;
    fields: InfoCardBulkSelectionField[];
}

interface InfoCardBulkSelectionProps {
    items: InfoCardBulkSelectionItem[];
    actions?: MenuItem[];
    content?: ReactNode;
    children?: ReactNode;
}

export default function InfoCardBulkSelection({
    items,
    actions,
    content,
    children,
}: InfoCardBulkSelectionProps): ReactNode {
    return (
        <InfoCardWrapper title="Bulk selection" actions={actions}>
            {items.map((item, index) => (
                <Panel
                    header={`${String(index + 1)}. ${item.panelHeader}`}
                    key={item.key}
                >
                    <div className="flex flex-column align-items-start">
                        {item.fields.map((field) => (
                            <ListableInfo
                                key={field.label}
                                label={field.label}
                                value={field.value}
                            />
                        ))}
                    </div>
                </Panel>
            ))}
            {content}
            {children}
        </InfoCardWrapper>
    );
}
